import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "asFormHomework",
  ref: "asFormHomeworkEl"
}
const _hoisted_2 = {
  key: 0,
  class: "asFormHomework_overlay"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "-borderTop" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "asFormHomework_previews" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "asFormHomework_content" }
const _hoisted_10 = {
  key: 0,
  class: "asFormHomework_uploader"
}
const _hoisted_11 = { class: "asFormHomework_uploaderWrapper" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "asFormHomework_asFileDnD_icon" }, null, -1)
const _hoisted_13 = { class: "asFormHomework_asFileDnD_text" }
const _hoisted_14 = { class: "asFormHomework_message" }
const _hoisted_15 = ["data-placeholder"]
const _hoisted_16 = {
  key: 1,
  class: "asFormHomework_dropDown"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_file_uploader = _resolveComponent("as-file-uploader")!
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_camera = _resolveComponent("as-camera")!
  const _component_as_file_drag_and_drop = _resolveComponent("as-file-drag-and-drop")!
  const _component_as_drop_down = _resolveComponent("as-drop-down")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.homeworkSending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args))),
      class: "asFormHomework_borderTop"
    }, _hoisted_4),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleVisibility && _ctx.toggleVisibility(...args))),
      class: "asFormHomework_title"
    }, _toDisplayString(_ctx.$t('Pass your homework')), 1),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, id) => {
        return (_openBlock(), _createElementBlock("li", {
          key: id,
          class: "asFormHomework_preview"
        }, [
          (file.type === 'image')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: file.urls.small,
                alt: "",
                class: "asFormHomework_image"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          (file.type === 'video')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (file.type === 'video')
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      src: file.url,
                      class: "asFormHomework_video",
                      controls: ""
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            onClick: ($event: any) => (_ctx.removeFile(file)),
            class: "asFormHomework_remove"
          }, null, 8, _hoisted_8)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (!_ctx.isUploadFileNone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_mq_responsive, { target: "mobile-tablet" }, {
              default: _withCtx(() => [
                _createVNode(_component_as_file_uploader, {
                  accept: '',
                  showButton: false,
                  showIcon: false,
                  showPreview: false,
                  onLoad: _ctx.addFile,
                  onLoadingFile: _ctx.onLoadingFile,
                  class: "asFormHomework_fileUploader -homework",
                  ref: "elFileUpload"
                }, null, 8, ["onLoad", "onLoadingFile"])
              ]),
              _: 1
            }),
            _createVNode(_component_mq_responsive, { target: "desktop" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_as_camera, {
                    onGetRecordData: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addFile($event)))
                  }),
                  _createVNode(_component_as_file_drag_and_drop, {
                    accept: '',
                    forceUpload: true,
                    showButton: false,
                    showIcon: false,
                    showPreview: false,
                    uploadErrorMessage: 'error.uploadFile',
                    onLoad: _ctx.addFile,
                    onLoadingFile: _ctx.onLoadingFile,
                    class: "asFormHomework_fileUploader -homework",
                    ref: "elFileUpload"
                  }, {
                    start: _withCtx(() => [
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Attach file')), 1)
                    ]),
                    _: 1
                  }, 8, ["uploadErrorMessage", "onLoad", "onLoadingFile"])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.isShowMessageBox)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "asFormHomework_textarea",
              contenteditable: "true",
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.input && _ctx.input(...args))),
              onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args))),
              ref: "messageEl",
              "data-placeholder": _ctx.$t('input.homework'),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.triggerFocus && _ctx.triggerFocus(...args)))
            }, null, 40, _hoisted_15))
          : _createCommentVNode("", true),
        (_ctx.isShowExercise)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_as_drop_down, {
                "position-menu": "top",
                "model-value": _ctx.selectedExercise,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeExercise($event))),
                items: _ctx.exerciseList,
                placeholder: _ctx.$t('selectNameExercise'),
                accordion: !_ctx.mq.desktop,
                onToggle: _cache[7] || (_cache[7] = ($event: any) => (!_ctx.mq.desktop ? _ctx.setHeightForMobile() : null))
              }, null, 8, ["model-value", "items", "placeholder", "accordion"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_mq_responsive, { target: "desktop" }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: _normalizeClass([{ '-disabled': _ctx.isSubmitBtnDisabled }, "asFormHomework_button"]),
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, _toDisplayString(_ctx.submitButtonText), 3)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_mq_responsive, { target: "mobile-tablet" }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
            class: _normalizeClass(["asFormHomework_button", { '-disabled': _ctx.isSubmitBtnDisabled }]),
            disabled: _ctx.isSubmitBtnDisabled
          }, _toDisplayString(_ctx.submitButtonText), 11, _hoisted_17)
        ]),
        _: 1
      }),
      (_ctx.expertsChatId)
        ? (_openBlock(), _createBlock(_component_mq_responsive, {
            key: 1,
            target: "mobile-tablet",
            class: "asFormHomework_text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('IfYouHaveQuestionOrDifficult')) + " ", 1),
              _createElementVNode("a", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToExpertChat(_ctx.expertsChatId)))
              }, _toDisplayString(_ctx.$t('writeToExpert')), 1),
              (_ctx.isShowSupportBtn(_ctx.homework.status.streamId))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_18,
                    _createElementVNode("a", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToSupport(_ctx.homework.status.streamId)))
                    }, _toDisplayString(_ctx.$t('passAllTasks.refuse')), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('passAllTasks.text')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.expertsChatId)
      ? (_openBlock(), _createBlock(_component_mq_responsive, {
          key: 1,
          target: "desktop",
          class: "asFormHomework_text"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('IfYouHaveQuestionOrDifficult')) + " ", 1),
            _createElementVNode("a", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToExpertChat(_ctx.expertsChatId)))
            }, _toDisplayString(_ctx.$t('writeToExpert')), 1),
            (_ctx.isShowSupportBtn(_ctx.homework.status.streamId))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_19,
                  _createElementVNode("a", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToSupport(_ctx.homework.status.streamId)))
                  }, _toDisplayString(_ctx.$t('passAllTasks.refuse')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('passAllTasks.text')), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 512))
}